import axios from 'axios';

import router from '@/router/index';
import { Message } from 'element-ui';
import { getUserInfo } from '@/utils/storage';

const service = axios.create({
    withCredentials: true,
    baseURL:  process.env.API_URL,
    timeout: 60*1000*5,//五分钟超时
    headers:{'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'},
});


//请求拦截器
service.interceptors.request.use(
    config => {
        const userInfo = getUserInfo();
        if (userInfo && userInfo.token) {
            config.headers.token = userInfo.token;
        }
        //获取分站path
        const siteId = window.location.pathname.split('/')[1];
        // 将 siteId 添加到请求头
        if (siteId) {
            config.headers['X-Site-Id'] = siteId;  // 添加自定义 header
        }
        // const siteId = router.currentRoute.params.stationId || 'default';
        // config.headers['X-Site-Id'] = siteId;
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

//响应拦截器
service.interceptors.response.use(
    response => {
        if (response.data.code === 1) {
            return response.data.data;
        } else if (response.data.code === 0) {
            Message.error(response.data.msg);
            return Promise.reject(response.data);
        } else {
            Message.error('未知错误');
            return Promise.reject(response.data);
        }
    },
    error => {
        Message.error('网络错误');
        return Promise.reject(error);
    }
);

service.install = (Vue) => {
    Vue.prototype.$http = service
  }

export default service;


// WEBPACK FOOTER //
// ./src/utils/request.js